// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommercialAgreement } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/CommercialAgreement';
import {
  ERR_FLUSH_EXPIRED_COMMERCIAL_AGREEMENT,
  SUC_FLUSH_EXPIRED_COMMERCIAL_AGREEMENT,
} from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useFlushExpiredCommercialAgreement = () => {
  const { submit } = useExerciseSubmission(
    CommercialAgreement.CommercialAgreement_FlushExpiredDeposit,
    SUC_FLUSH_EXPIRED_COMMERCIAL_AGREEMENT,
    ERR_FLUSH_EXPIRED_COMMERCIAL_AGREEMENT,
  );

  return submit;
};
